export * from './taiwan-id-number-format-strategy';
export * from './taiwan-id-number-length-strategy';
export * from './taiwan-id-number-strategy';
